<div class="sidebar-header">
  <h1
    class="app-name"
    [routerLink]="['/translation-editor']"
    (click)="onCloseSideNavClick()"
    (keydown)="onCloseSideNavKeyDown($event)"
  >
    Our Dictionary
  </h1>
  <button mat-icon-button (click)="onCloseSideNavClick()">
    <mat-icon svgIcon="ak-close" />
  </button>
</div>

<div class="menu-items">
  @for(item of menuItems(); track item) {
    <button class="mat-flat-button ake-secondary-button" [routerLink]="item.path" (click)="onCloseSideNavClick()" > {{item.label}} </button>
  }
</div>


<!--<ak-menu [menuItems]="menuItems()" (menuClicked)="onCloseSideNavClick()" />-->
